import React, { useContext } from 'react';
import { Row, Col } from '@sm/wds-react';
import { getAnonCategories } from './helpers';
import { InlineList, InlineListItem } from '../InlineList';
import { SMFooterContext } from '../SMFooterContext';

const AnonFooterLinks = () => {
  const { domain, lang, country, variant, onetrustBannerEnabled } = useContext(
    SMFooterContext
  );

  const categories = getAnonCategories(domain, lang, country, variant);
  const margin = variant === 'slim';
  return (
    <>
      {categories.map((category, i) => {
        return (
          <Row key={category[0].title}>
            <Col>
              <InlineList noMargin={margin}>
                {category.map(item => {
                  return (
                    <InlineListItem
                      href={item.url}
                      anchorAttributes={item.anchorAttributes}
                      key={`${item.title}`}
                      isTitle={item.isTitle}
                      lastItem={item.lastItem}
                    >
                      {item.title}
                    </InlineListItem>
                  );
                })}
                {i === 2 && onetrustBannerEnabled ? (
                  <li className="sm-inline-list__item">
                    {/* Onetrust pipes in the text content here */}
                    {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
                    <a
                      href="#cookiePreferences"
                      className="ot-sdk-show-settings"
                      data-testid="AnonFooterLinks__cookiePreferences"
                    />
                  </li>
                ) : null}
              </InlineList>
            </Col>
          </Row>
        );
      })}
    </>
  );
};

export default AnonFooterLinks;
